import React, { useState, useEffect } from 'react';
import {
	MenuItem,
	FormControl,
	Select,
	Card,
	CardContent
} from "@material-ui/core";
import InfoBox from './InfoBox.js';
import Map from './Map.js';
import Table from './Table.js';
import {sortData, prettyPrintStat} from './util.js';
import LineGraph from './LineGraph.js';
import './App.css';
import "leaflet/dist/leaflet.css";

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("worldwide");
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({lat: 0.0000, lng: 0.0000});
  const [mapZoom, setMapZoom] = useState(2);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");

  useEffect(() => {
  	fetch("https://disease.sh/v3/covid-19/all")
  	.then((response) => response.json())
  	.then((data) => {
  		setCountryInfo(data);
  	});
  }, []);
  useEffect(() => {
  	// async -> send a request, wait for it, do something
  	const getCountriesData = async () => {
  		await fetch("https://disease.sh/v3/covid-19/countries")
  		.then((response) => response.json())
  		.then((data) => {
  			const countries = data.map((country) => (
  			{
  				name: country.country,
  				value: country.countryInfo.iso2 // UK, USA
  			}));
  			const sortedData = sortData(data);
  			setTableData(sortedData);
  			setMapCountries(data);
  			setCountries(countries);
  		});
  	};
  	getCountriesData();
  }, []);

  const onCountryChange = async (event) => {
  	const countryCode = event.target.value;
  	setCountry(countryCode);
  	const url = countryCode === "worldwide" ? "https://disease.sh/v3/covid-19/all" : `https://disease.sh/v3/covid-19/countries/${countryCode}`;
  	await fetch(url)
  	.then(response => response.json())
  	.then(data => {
  		setCountry(countryCode);
  		setCountryInfo(data);
  		data.countryInfo ? setMapCenter([data.countryInfo.lat, data.countryInfo.long]) : setMapCenter([0, 0]);
  		data.countryInfo ? setMapZoom(4) : setMapZoom(2);
  	});
  };
  console.log(countryInfo);

  return (
    <div className="app">
    <div className="app__left">
		<div className="app__header">
    	<h1>COVID-19 Tracker</h1>
        <FormControl className="app__dropdown">
      	<Select
      	  onChange = {onCountryChange}
      	  variant="outlined"
      	  value={country}
      	>
      	<MenuItem value="worldwide">Worldwide</MenuItem>
      	{ countries.map(country => (
      		<MenuItem value={country.value}>{country.name}</MenuItem>
      	))}
      	</Select>
        </FormControl>
    </div>
    <div className="app__stats">
    	<InfoBox
    		isRed
    		active={casesType === "cases"} 
    		onClick={(e) => setCasesType("cases")}
    		title="Coronavirus Cases" 
    		cases={prettyPrintStat(countryInfo.todayCases)} 
    		total={prettyPrintStat(countryInfo.cases)}
    	/>
    	<InfoBox 
    		active={casesType === "recovered"}
    		onClick={(e) => setCasesType("recovered")}
    		title="Recovered" 
    		cases={prettyPrintStat(countryInfo.todayRecovered)} 
    		total={prettyPrintStat(countryInfo.recovered)}
    	/>
    	<InfoBox
    		isRed
    		active={casesType === "deaths"}
    		onClick={(e) => setCasesType("deaths")} 
    		title="Deaths" 
    		cases={prettyPrintStat(countryInfo.todayDeaths)} 
    		total={prettyPrintStat(countryInfo.deaths)}
    	/>
    </div>
    <Map 
      casesType={casesType}
      countries={mapCountries}
	  center={mapCenter}
	  zoom = {mapZoom}
    />
    </div>
    <Card className="app__right">
		<CardContent>
		<h3>Live Cases by Country</h3>
		<Table countries={tableData}/>
		<br/>
		<h3>Worldwide New {casesType}</h3>
		<LineGraph casesType={casesType} />
		</CardContent>
    </Card>
    </div>
  );
}

export default App;
